export const appConfig = {
	/**
	 * TRUE: forzi le chiamate token
	 */
	forceToken: false,

	/**
	 * TRUE: simuli le chiamate cerved
	 */
	isTest: false,

	/**
	 *
	 */
	PRIVACY_LINK: "https://buffettifinance.com/privacy-policy/",

	/**
	 * Intervallo (in ms) per polling chiamata Identification (verifica identità step-6)
	 */
	spidVerificationTimer: 10000,

	/**
	 * n° di tentativi per polling chiamata Identification (verifica identità step-6)
	 */
	spidVerificationAttemps: 12,
};
